import { authenticatedApiFetch } from '../utils/utils'

export const filteredQCMStudentNotesService = async (filter) => {
	const res = await authenticatedApiFetch(`/qcm-student-notes/?${filter}`, { method: 'GET' })
		.then(res => res.json())
		.catch(error => console.error(error))
	return res
}
